const SuperAdmin = () => import('@/modules/SuperAdmin')

import accountSharing from '@/router/routes/auth/superAdmin/accountSharing'
import accountingFirms from '@/router/routes/auth/superAdmin/accountingFirms'
import applications from '@/router/routes/auth/superAdmin/applications'
import customers from '@/router/routes/auth/superAdmin/customers'
import flags from '@/router/routes/auth/superAdmin/flags'
import gedImport from '@/router/routes/auth/superAdmin/gedImport'
import home from '@/router/routes/auth/superAdmin/home'
import jobTrackers from '@/router/routes/auth/superAdmin/jobTrackers'
import mobileApps from '@/router/routes/auth/superAdmin/mobileApps'
import modules from '@/router/routes/auth/superAdmin/modules'
import products from '@/router/routes/auth/superAdmin/products'
import support from '@/router/routes/auth/superAdmin/support'
import themes from '@/router/routes/auth/superAdmin/themes'
import treeStructures from '@/router/routes/auth/superAdmin/treeStructures'

export default [
	{
		component: SuperAdmin,
		meta: {
			super_admin: true
		},
		name: 'sa',
		path: 'sa',
		redirect: 'sa-home',
		children: [
			...accountSharing,
			...accountingFirms,
			...applications,
			...customers,
			...flags,
			...gedImport,
			...home,
			...jobTrackers,
			...mobileApps,
			...modules,
			...products,
			...support,
			...themes,
			...treeStructures
		]
	}
]
